import { EULA_INFO } from 'api/admin/types';
import { DocType, Language, Risk } from 'api/file/interfaces/get-file-order-insights';

export const HELP_ROUTE = '/help';
export const HELP_SEARCH_ROUTE = `${HELP_ROUTE}/search`;
export const HELP_COLLECTION_SLUG = 'agentnet';
export const HELP_SITE_SETTINGS_ID = '7Cb1Fdl72TOOso0C1lBmMf';

// Fraud Prevention Product Codes
export const CONTACT_VALIDATION_PRODUCT_CODE = 'FP001';
export const IDENTITY_VERIFICATION_PRODUCT_CODE = 'FP002';
export const WIRE_VALIDATION_PRODUCT_CODE = 'FP003';
export const TITLE_MONITORING_PRODUCT_CODE = 'FP004';

// Contentful Asset IDs
export const FRAUD_RAPID_RESPONSE_ASSET_ID = '6HiT419EnUdopbXMEN1YzH';

const commonEulatext =
  'By using the serviceName <b>Service</b> the user agrees The serviceName <b>Service</b> is provided under the AgentNet® END USER LICENSE AGREEMENT as a “licensed product.” . The serviceName <b>Service</b> is provided as a service solely for Agents of First American Title Insurance Company to assist in fraud prevention as a supplemental identity verification tool. First American Title Insurance Company disclaims all liability for unauthorized use.  The serviceName <b>Service</b> is supplemental to and does not replace First American Title Insurance Company’s underwriting standards or industry best practices.';

export const EULA_Texts: EULA_INFO = {
  'Contact Validation': commonEulatext,
  'Enhanced Identity Verification': commonEulatext,
  'Wire Validation': commonEulatext,
};

export const VERIFICATION_TIME_LIMIT_MESSAGE =
  'Before submitting the request, confirm with the party which document they will use for identity verification and their preferred language for receiving the request.';

export const TRANSACTION_MESSAGE =
  'Protect your transactions by confirming each party’s identity using a government-issued ID and live selfie.';

export const EMAIL_VERIFICATION_SUBMITION_GUIDE = `The party will have 30 minutes from the moment they click the "Start" button in the email to complete the verification process.`;

export const TEXT_VERIFICATION_SUBMITION_GUIDE = `The party will have 30 minutes from the time the text was sent to complete the verification process. `;

export const disableIntegrationText: EULA_INFO = {
  FP001:
    'This integration will no longer be available within Order Insights to validate party contact information. Previously validated contact information will also be unavailable. Do you wish to continue?',
  FP002:
    'This integration will no longer be available within Order Insights to verify party identities. Previously verified results will also be unavailable. Do you wish to continue?',
  FP003:
    'This add-on will no longer be available in Services to validate wires. Previously verified results will also be unavailable. Do you wish to continue?',
};

export const offerMessage = {
  admin: 'Enable this feature in your Admin settings.',
  nonAdmin: "Contact your firm's AgentNet Administrator to enable this feature.",
};

export const OFFER_DETAILS_PENDING = {
  ContactValidation: 'Please add a phone number or email address to the party to use Contact Validation',
  EnhancedIdentityVerification: 'Please add a phone number to the party to use Identity Verification',
};

export const RETRY_VERIFICATION_TEXT =
  'The party failed to complete identity verification. You can send the request count more times.';

export const MAX_IDENTITY_CHECK_ATTEMPTS = 3;

export const MAX_ATTEMPTS_VERIFICATION_TEXT =
  'The party failed to complete identity verification within the allowed 3 attempts. For security reasons, no additional verification attempts are permitted.';

export const validationAlertRisk: Risk = {
  category: 1,
  categoryName: 'Party',
  typeName: 'Validation',
  severity: 1,
  severityName: 'Alert',
  title: 'Validation Risk',
  description: 'One or more validation checks triggered a risk alert.',
  type: 1,
};

export const enhancedVerificationPendingRisk: Risk = {
  category: 1,
  categoryName: 'Party',
  typeName: 'EnhancedIdentityVerification',
  severity: 5,
  severityName: 'Pending',
  title: 'Verification in progress',
  description: 'The enhanced identity check is still pending.',
  type: 1,
};

export const enhancedVerificationFailedRisk: Risk = {
  category: 1,
  categoryName: 'Party',
  typeName: 'EnhancedIdentityVerification',
  severity: 4,
  severityName: 'Error',
  title: 'Verification failed',
  description: 'The enhanced identity check failed to complete successfully.',
  type: 1,
};

export const pdfProductEnableMessage =
  'This feature is not available. Contact your firm’s AgentNet Administrator to enable this feature.';

export const identityReportAvailableText =
  'The Identity Verification Report is available for download until <strong>expiryDate</strong>. After this time, you will need to submit a new identity verification request to access the results. We recommend downloading the PDF now to keep a copy for your records.';

export const oldVerificationRequestText =
  'This request is older than 90 days. Due to our retention guidelines, a new identity verification request is required to view the Identity Verification Report.';

export const docTypeValue = {
  [DocType.NORTH_AMERICAN_DRIVER_LICENSE]: "North American Driver's License/Identification Card",
  [DocType.PASSPORT]: 'Passport Booklet',
  [DocType.OTHER]: 'Other Document',
};

export const docTypeOptions = [
  { value: DocType.NORTH_AMERICAN_DRIVER_LICENSE, name: docTypeValue[DocType.NORTH_AMERICAN_DRIVER_LICENSE] },
  { value: DocType.PASSPORT, name: docTypeValue[DocType.PASSPORT] },
  { value: DocType.OTHER, name: docTypeValue[DocType.OTHER] },
];

export const languageValue = {
  [Language.ENGLISH]: 'English',
  [Language.SPANISH]: 'Spanish',
  [Language.FRENCH]: 'French',
};

export const languageOptions = [
  { value: Language.ENGLISH, name: languageValue[Language.ENGLISH] },
  { value: Language.SPANISH, name: languageValue[Language.SPANISH] },
  { value: Language.FRENCH, name: languageValue[Language.FRENCH] },
];

export const mismatchDLText =
  'Highlighted fields indicate differences between the barcode on the back of the ID and the information on the front.';

export const mismatchPassportText =
  'Highlighted fields indicate differences between the Machine Readable Zone (MRZ) data and the information on the front of the passport.';

export const requestTimeOutText = 'The identity verification request has timed out.';
export const requestTimeOutHelpText = 'Please reach out to your underwriting agent for assistance.';
export const unexpectedErrorText = 'An unexpected error occurred.';
export const unexpectedErrorHelpText = 'Please try again or reach out to your underwriting agent for assistance.';
export const cancelledText =
  'Once cancelled, the party will no longer be able to complete the verification process. You may submit a new verification request if needed.';

export const pendingAwaitingText =
  'The party has not yet started the verification process. Once they start, they will have 30 minutes to complete the identity verification process.';

export const pendingText = 'The party has started the verification process. The request must be completed by {time}';
export const completedText = 'This identity verification request has already been completed.';
export const furtherAssistanceText = 'Please reach out to your underwriting agent if you need further assistance.';
export const CONTACT_VALIDATION_MESSAGE =
  'Protect your transactions by quickly gathering information about the party’s phone number, email, and street address.';
export const CONTACT_VALIDATION_INFO = 'The provided information will be validated and saved to the party on file.';
export const DRAWER_TRANSACTION_MESSAGE =
  "Confirm the party's identity using a government-issued ID and live selfie. Sends verification request via text/email.";
export const DRAWER_CONTACT_VALIDATION_MESSAGE =
  'Protect your transactions by quickly validating contact information. Complete all fields for comprehensive results.';

export const NON_FA_UNDERWRITER_DISABLED_MESSAGE = "{ProductName} isn't enabled for non-First American underwriters.";
export const FA_UNDERWRITER_DISABLED_MESSAGE = "{ProductName} isn't enabled for First American underwriters.";
export const NON_FA_UW_PARTY_VERIFICATION_HEADING = 'Need to verify parties for non-First American underwriters?';
export const NON_FA_UW_WIRE_VALIDATION_HEADING = 'Need to validate wires for non-First American underwriters?';

export const PARTY_VERIFICATION_MESSAGE =
  'Protect your transactions with comprehensive party verification. Validate contact information instantly and confirm identities using government-issued IDs and live selfies—all in one streamlined process. Reduce fraud risk and ensure compliance with fast, reliable verification.';

export const WIRE_VALIDATION_MESSAGE =
  'Protect your transactions by verifying wire transfer information. Validate bank account details to help prevent wire fraud before funds are sent.';

export const KNOWLEDGE_BASE_TERMS_OF_USE = 'https://www.firstam.com/terms-of-use/index.html';
export const KNOWLEDGE_BASE_PRIVACY_POLICY = 'https://www.firstam.com/privacy-policy/index.html';
export const KNOWLEDGE_BASE_EULA = `${HELP_ROUTE}/admin-settings/agentnet-r-end-user-license-agreement-eula`;
export const PARTY_VERIFICATION_SUBTITLE =
  'Initiate and track Contact Validation and Identity Verification requests to help validate parties. Review verification status and results to help reduce fraud risk and support compliance requirements.';

export const WIRE_VALIDATION_SUBTITLE =
  'Run Wire Validations to verify that an individual or business is associated with a bank account. Review validation results to help reduce fraud risk and support secure financial transactions.';
